import { render, staticRenderFns } from "./ModifyThesis.vue?vue&type=template&id=61f4f4b4&scoped=true"
import script from "./ModifyThesis.vue?vue&type=script&lang=js"
export * from "./ModifyThesis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4f4b4",
  null
  
)

export default component.exports